// only act as a reference point to gather localizations
// register create function for bundleid
Oskari.bundle('asdi-lang-overrides', () => {
  return {
    start: () => {/* no-op */},
    stop: () => {/* no-op */}
  };
});